import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayout } from '../../contexts/LayoutContext';

const ShowMoreButton = () => {
  const navigate = useNavigate();
  const { navCollapsed } = useLayout();

  const handleClick = () => {
    navigate('/app/conversations');
  };

  if (navCollapsed) {
    return (
      <div className="show-more-btn collapsed" onClick={handleClick} title="View all conversations">
        <span>⋯</span>
      </div>
    );
  }

  return (
    <div className="show-more-btn" onClick={handleClick}>
      <span>View all conversations →</span>
    </div>
  );
};

export default ShowMoreButton;